export enum DoorSwingDirection {
  In = 'in',
  Out = 'out',
}
